export default __webpack_public_path__ + "static/media/apple-logo.f3c68cc2.svg";